// extracted by mini-css-extract-plugin
var _1 = "webpack-components-shared-CompactPagination-CompactPagination-module__box";
var _2 = "webpack-components-shared-CompactPagination-CompactPagination-module__pageInput";
var _3 = "webpack-components-shared-CompactPagination-CompactPagination-module__slashText";
export { _1 as "box", _2 as "pageInput", _3 as "slashText" }
